import { ComponentsOverrides, ComponentsProps, Theme } from '@mui/material';
import fontsConfig from 'theme/fonts';

interface IMuiPickersDay {
  defaultProps?: ComponentsProps['MuiPickersDay'];
  styleOverrides?: ComponentsOverrides<Theme>['MuiPickersDay'];
}

const MuiPickersDayConfig: IMuiPickersDay = {
  styleOverrides: {
    root: ({ theme }) => ({
      fontSize: fontsConfig.sizes.default,
      '&.MuiPickersDay-root': {
        '&.Mui-selected': {
          backgroundColor: theme.palette.primary.dark,
          color: theme.palette.primary.contrastText,
          borderRadius: 6,
        },
      },
    }),
    today: {
      borderRadius: 6,
    },
  },
};

export default MuiPickersDayConfig;
